// extracted by mini-css-extract-plugin
export default {"container":"StudentActivities_container__uL9o4"};